import apiClient from './index';

export interface ApiKey {
  id: number;
  name: string;
  key_prefix: string;
  role: 'admin' | 'readonly';
  is_active: boolean;
  expires_at: string | null;
  created_at: string;
  last_used: string | null;
  created_by_username: string;
}

export interface CreateApiKeyRequest {
  name: string;
  role: 'admin' | 'readonly';
  expires_at?: string | null;
}

export interface CreateApiKeyResponse {
  status: string;
  api_key: {
    id: number;
    name: string;
    key: string;
    key_prefix: string;
    role: string;
    expires_at: string | null;
  };
  message: string;
}

export async function getApiKeys(): Promise<ApiKey[]> {
  const response = await apiClient.get<ApiKey[]>('/spex/plus/api-keys');
  return response.data;
}

export async function createApiKey(data: CreateApiKeyRequest): Promise<CreateApiKeyResponse> {
  const response = await apiClient.post<CreateApiKeyResponse>('/spex/plus/api-keys', data);
  return response.data;
}

export async function revokeApiKey(keyId: number): Promise<{ status: string; message: string }> {
  const response = await apiClient.delete(`/spex/plus/api-keys/${keyId}`);
  return response.data;
}
